/**
 * LoggingMixin — Atalhos para uso do LogService nos componentes Vue.
 *
 * Inclua com: mixins: [LoggingMixin]
 * Use com:    this.$log.logMarkedAsPaid(nome, campanha)
 *
 * Todos os métodos delegam para LogService, que segue o padrão:
 *   [MÓDULO] [AÇÃO] descrição clara
 */
import LogService from "@/services/LogService";

export default {
  methods: {
    // Expõe o LogService diretamente via this.$log para uso nos componentes
  },
  created() {
    this.$log = LogService;
  },
};